import React from 'react'

const Publications = () => {
    return (
        <div className="container sec1 flex">
            <div className="main">
            </div>
        </div>
    )
}

export default Publications;